import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';
import differenceBy from 'lodash/differenceBy';
import cn from 'classnames';

import {Select} from 'components';
import * as utils from 'utils';

import styles from './FilterLocations.module.scss';
import Context from '../../../../context';
import {HEADING_ONLINE, HEADING_USA} from '../../../../constants';
import {reducerFilters} from '../../../../reducers';
import {sortByName, sortByNameWithOther} from '../../../../helpers';
import {components} from 'react-select';

const createOptions = (arr, type) =>
  arr.map(label => ({
    value: `locations--${type}--${label}`,
    label,
  }));

export const FilterLocations = () => {
  const {
    data,
    loading,
    filters: {locations},
    dispatchFilters,
  } = useContext(Context);

  const arrCountries = sortByName(
    compact([
      ...new Set(
        data.filter(item => item.country !== 'USA').map(item => item.country),
      ),
    ]),
  );
  const arrStates = sortByName(
    compact([
      ...new Set(
        data.filter(item => item.country === 'USA').map(item => item.state),
      ),
    ]),
  );
  const arrVirtualGroups = sortByNameWithOther(
    compact([...new Set(compact(data.map(item => item.onlinePlatform)))]),
  );

  const optionsStates = createOptions(arrStates, 'state');
  const optionsCountries = createOptions(arrCountries, 'country');
  const optionsVirtualGroups = createOptions(arrVirtualGroups, 'online');

  const options = [
    {
      label: HEADING_USA,
      options: optionsStates,
    },
    ...optionsCountries,
    {
      label: HEADING_ONLINE,
      options: optionsVirtualGroups,
    },
  ];

  const handleChange = values => {
    // Tracking Analytics
    const items = values.map(item => item.label).join(', ');
    utils.handleAnalytics('dropdown', 'locations', items);

    dispatchFilters({
      type: reducerFilters.actionTypes.updateLocations,
      payload: values || [],
    });
  };

  const GroupHeading = props => {
    const locationsWithoutStates = differenceBy(
      locations,
      optionsStates,
      'value',
    );
    const locationsWithoutVirtual = differenceBy(
      locations,
      optionsVirtualGroups,
      'value',
    );
    const isUSA = props.children === HEADING_USA;
    const isVirtual = props.children === HEADING_ONLINE;
    const isSelected =
      (isUSA &&
        arrStates.length ===
        locations.length - locationsWithoutStates.length) ||
      (isVirtual &&
        arrVirtualGroups.length === locations.length - locationsWithoutVirtual.length);

    const handleClickGroupHeadingUSA = () => {
      if (isUSA) handleChange([
        ...(isSelected ? [] : optionsStates),
        ...locationsWithoutStates,
      ]);

      if (isVirtual) handleChange([
        ...(isSelected ? [] : optionsVirtualGroups),
        ...locationsWithoutVirtual,
      ]);
    };

    return (
      <components.GroupHeading
        className={cn(styles.chosenGroupHeading, {
          [styles.isSelected]: isSelected,
        })}
        onClick={handleClickGroupHeadingUSA}
        {...props}
      />
    );
  };

  GroupHeading.propTypes = {
    children: PropTypes.node,
  };

  return (
    <Select
      className={styles.wrap}
      multiple
      placeholder="All Locations"
      controlAmountText="locations"
      value={locations}
      options={options}
      loading={loading}
      GroupHeading={GroupHeading}
      onChange={handleChange}
    />
  );
};
